'use strict';

const helper = require('../../helper');
const venmoHelper = require('../helpers/venmoHelper');

const saveVenmoCheckbox = document.getElementById('braintreeSaveVenmoAccountContainer');
const braintreeVenmoUserIdEl = document.getElementById('braintreeVenmoUserId');
const braintreeVenmoNonceEl = document.getElementById('braintreeVenmoNonce');
const venmoAccountBlockEl = document.querySelector('.js-braintree-used-venmo-account');
const venmoButtonEl = document.querySelector('.js-braintree-venmo-button');

let sessionOptionEl = document.getElementById('sessionVenmoAccount');

const JS_USED_VENMO_ACCOUNT = 'js-used-venmo-account';
const USED_VENMO_ACCOUNT_HIDE = 'used-venmo-account-hide';

/**
 * Handles showing Venmo session account
 */
function showVenmoSessionAccount() {
    saveVenmoCheckbox?.classList.add('d-none');

    const btVenmoAccountsList = document.getElementById('braintreeVenmoAccountsList');
    const venmoContentEl = document.querySelector('.js-braintree-venmo-content');

    if (braintreeVenmoUserIdEl.value) {
        // Create the option element if it doesn't exist
        if (!sessionOptionEl) {
            sessionOptionEl = document.createElement('option');
            sessionOptionEl.id = 'sessionVenmoAccount';
            sessionOptionEl.value = 'sessionvenmo';
            sessionOptionEl.setAttribute('data-nonce', braintreeVenmoNonceEl.value);
            sessionOptionEl.textContent = braintreeVenmoUserIdEl.value;
            btVenmoAccountsList.appendChild(sessionOptionEl);
        }

        sessionOptionEl.selected = true;

        venmoButtonEl.classList.add('d-none');

        helper.continueButtonToggle(false);

        if (venmoAccountBlockEl.classList.contains(USED_VENMO_ACCOUNT_HIDE)) {
            venmoAccountBlockEl.classList.remove(USED_VENMO_ACCOUNT_HIDE);
        }
    } else {
        btVenmoAccountsList.removeChild(sessionOptionEl);
    }

    // Set attribute to show "place order" button
    venmoContentEl.setAttribute('data-paypal-is-hide-continue-button', false);
    // Hide Venmo button
    venmoButtonEl.setAttribute('data-is-hide-venmo-button', true);
}

/**
 * Clears the Venmo session account
 */
function clearSessionAccount() {
    if (sessionOptionEl) {
        sessionOptionEl.remove();
    }
}

/**
 * Removes method was used and change appearance of Venmo tab
 */
function removeSessionNonce() {
    const defaultOption = helper.getOptionByDataDefault('#braintreeVenmoAccountsList');
    const braintreeVenmoNonce = document.getElementById('braintreeVenmoNonce');
    const braintreeVenmoBilling = document.getElementById('braintreeVenmoBilling');

    clearSessionAccount();

    if (defaultOption) {
        defaultOption.selected = true;

        venmoHelper.venmoContentTabHandler();
    } else {
        venmoAccountBlockEl.classList.remove(JS_USED_VENMO_ACCOUNT);
        venmoAccountBlockEl.classList.add(USED_VENMO_ACCOUNT_HIDE);
        venmoButtonEl.style.display = 'block';
    }

    braintreeVenmoNonce.value = '';
    braintreeVenmoBilling.value = '';
}

module.exports = {
    showVenmoSessionAccount,
    removeSessionNonce
};
